import PageContainer from "@/component/pageContainer";
import { Loading, Toast } from "@xp-design/mobile";
import FontSetBox from "@/component/fontSetBox";
import FontSetBoxs from "@/component/fontSetBox/fontSetBoxNew";
// import { goBack } from '@/utils/tools'
import { useEffect, useMemo, useRef, useState } from "react";
import {
  chartRankingInfoList,
  getInvitationMessage,
  individualLeaderboard,
  joinTheTeam,
  teamLeaderboard,
} from "./ajax";
import style from "./index.module.less";
import { getCurrentUid } from "@/api/common";
import OneTwoThreeBox from "./components/oneTwoThreeBox";
import FooterInfoBox from "./components/footerInfoBox";
import RankList from "./components/rankList";
import { RightOutline } from "antd-mobile-icons";
import { useSearchParams } from "react-router-dom";
import { goToPageV2, debounce } from "@/utils/common";
import {
  ActivityData,
  UserActivityData,
  IndividualLeaderboard,
  ShareInfoData,
} from "./type";
import { homeData } from "./fakeData";
import { getChannel } from "@/utils/tools";
import { trackGdp } from "@/utils/gio-report";
import PopupCom from "@/component/popupCom";
import { enhancedSafeChainFind } from "../../utils";
import ActivityDetailPopup, {
  ActivityDetailPopupRef,
} from "@/components/ActivityDetailPopup";
import PrizeRecordPopup, {
  PrizeRecordPopupRef,
} from "@/components/PrizeRecordPopup";
import ActivityDetailButton from "@/components/ActivityDetailButton";
import { teamMemberList } from "@/pages/par-marketing/myTeam/ajax";
import { ApiResponse } from "@/pages/par-marketing/detailPage/type";
import { processOssImage } from "@/utils/image";
import { getParamsFromHash, removeUrlParameters } from "@/utils/url";
type Props = {
  // activityInfo: any;
  // moduleJsonData: any; //
  // navHeight: any;
};
let pageNo = 1;
let pageSize = 20;
const App = (props: Props) => {
  const [searchParams] = useSearchParams();
  const PopupComRef = useRef<any>(null);
  // 活动详情弹窗引用
  const activityDetailPopupRef = useRef<ActivityDetailPopupRef>(null);
  // 中奖记录弹窗引用
  const prizeRecordPopupRef = useRef<PrizeRecordPopupRef>(null);
  const moduleJsonData = JSON.parse(
    localStorage.getItem(`moduleJsonData${getParamsFromHash("moduleId")}`) ||
      "{}",
  );
  const activityInfo = JSON.parse(
    localStorage.getItem(`activityInfo${getParamsFromHash("moduleId")}`) ||
      "{}",
  );
  const boxBackUrl = useMemo(
    //排行组件 背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("bgSetting")
        ?.content("rankBg")?.val?.val;
      return result || moduleJsonData.visual?.prizeSetting[0]?.content[0]?.val;
    },
    [moduleJsonData],
  );
  const activityCode = useMemo(
    //活动详情
    () => {
      const result =
        enhancedSafeChainFind(moduleJsonData)?.base("reActivity")?.val?.valCode;
      return result || moduleJsonData?.base?.[0]?.val?.valCode;
    },
    [moduleJsonData],
  );
  // const { pageOrigin } = useConfigPage();
  const tabIsAll = useMemo(
    //活动 Tab 显示 全部
    () => {
      // if (process.env.NODE_ENV == "development") {
      //   return true;
      // }
      return (
        moduleJsonData?.rewardSet?.rankingType == "1,2" ||
        moduleJsonData?.rewardSet?.rankingType == "2,1"
      );
    },
    [moduleJsonData],
  );
  // 页面大小相关的数据取值
  const personRankNumData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "personRankNum",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[2]?.val;
  }, [moduleJsonData]);

  const teamRankNumData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "teamRankNum",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData[3]?.val;
  }, [moduleJsonData]);

  // 业务逻辑保持在原位置
  const personPageSize =
    (personRankNumData ? personRankNumData - 0 : null) || 20;
  const teamPageSize = (teamRankNumData ? teamRankNumData - 0 : null) || 20;

  // 标题内容相关的useMemo
  const titleContent = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "title",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[1]?.val;
  }, [moduleJsonData]);

  const subTitleContent = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "subTitle",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[2]?.val;
  }, [moduleJsonData]);

  const activityValueName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "activityValueName",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[3]?.val;
  }, [moduleJsonData]);

  // 样式数据相关的useMemo
  const activityTitleStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activityTitle")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[0]
        ?.styleData
    );
  }, [moduleJsonData]);

  const activitySubTitleStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activitySubTitle")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[1]
        ?.styleData
    );
  }, [moduleJsonData]);

  const updateTimeStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("updateTime")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[4]
        ?.styleData
    );
  }, [moduleJsonData]);

  // 排名类型数据取值
  const rankTypeData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData(
      "rankType",
    )?.val?.val;
    return result || moduleJsonData?.rankImg?.rankData?.[0]?.val;
  }, [moduleJsonData]);

  // 可展示个人排名数
  const personRankNum = useMemo(() => {
    const result =
      enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData("personRankNum")
        ?.val?.val || "";
    return result;
  }, [moduleJsonData]);

  // 可展示组队排名数
  const teamRankNum = useMemo(() => {
    const result =
      enhancedSafeChainFind(moduleJsonData?.rankImg)?.rankData("teamRankNum")
        ?.val?.val || "";
    return result;
  }, [moduleJsonData]);

  // 业务逻辑保持在原位置
  const isTeamType = rankTypeData == "组队";

  console.log("%c Line:34 🥖 moduleJsonData", "color:#b03734", moduleJsonData);
  // 是否关闭首页内容
  const [showHomeFlag, setShowHomeFlag] = useState(false);
  const [prizeMaskShow, setPrizeMaskShow] = useState(false);
  const goSeeAll = () => {
    pageNo = 1;
    setShowHomeFlag(false);
    localStorage.setItem(`isOneRankingOpen${activityInfo.moduleId}`, "1");
    if (isPeoModel) {
      pageSize = personPageSize;
    } else {
      pageSize = teamPageSize;
    }
    setTopThreePersonal([]);
    setRankDataList([]);
    getRankingListData(isPeoModel, 1);
  };

  //我的奖品
  const myAward = () => {
    // const activityInfo = props.activityInfo;
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: "大型排行榜",
      status: rankObj.activityStatusCn || "",
      clickLocation: "中奖记录",
    });
    // 使用弹窗显示中奖记录
    prizeRecordPopupRef.current?.show(activityCode);
  };
  const hdxq = useMemo(
    //活动详情
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("btnSetting")
        ?.content("rankDetails")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[2]?.val
      );
    },
    [moduleJsonData],
  );
  // 排名奖励
  const pmjlPopUpRef = useRef<any>(null);
  const pmjl = useMemo(
    // 排名奖励按钮图片
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("btnSetting")
        ?.content("rankReward")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[1]?.content?.[3]?.val
      );
    },
    [moduleJsonData],
  );
  const pmjlBackUrl = useMemo(
    //排名奖励 背景图
    () => {
      const result = enhancedSafeChainFind(moduleJsonData.visual)
        ?.prizeSetting("popSetting")
        ?.content("rankRewardPop")?.val?.val;
      return (
        result || moduleJsonData?.visual?.prizeSetting?.[2]?.content?.[0]?.val
      );
    },
    [moduleJsonData],
  );
  const [pmIndex, setPmIndex] = useState(0);
  const [pmjlData, setPmjlData] = useState<any[]>([]);
  const pmTabChange = (index: number) => {
    if (pmIndex == index) {
      return;
    }
    setPmjlData([]);
    setPmIndex(index);
    setTimeout(() => {
      setPmjlData(moduleJsonData.rewardSet.rewardData[index]?.data || []);
    }, 10);
  };
  // const pmjlData = useMemo(
  //   () => () => moduleJsonData.rewardSet.rewardData[pmIndex]?.data || [],
  //   [pmIndex]
  // );
  function truncateText(selector: string, lines: number) {
    const element = document.querySelector(selector);
    const lineHeight = 1.2; // 根据实际行高调整
    const maxHeight = lineHeight * lines;

    if (element && element.scrollHeight && element.scrollHeight > maxHeight) {
      const text = element.textContent;
      let truncatedText = text;

      while (element.scrollHeight > maxHeight && truncatedText) {
        truncatedText = truncatedText.slice(0, -1);
        element.textContent = truncatedText + "...";
      }
    }
  }
  const pmjlEvent = debounce(() => {
    document.body.style.pointerEvents = "none";
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
    setPrizeMaskShow(true);
    pmjlPopUpRef.current.onOpen();
    truncateText("#text-container", 2);
    // const activityInfo = props.activityInfo;
    trackGdp("P20189", "B004", {
      trackName: "充电_营销专题页_组件点击",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: "大型排行榜",
      status: rankObj.activityStatusCn || "",
      clickLocation: "排名奖励",
    });
  }, 500);
  const onCloseCallBack = async () => {
    setTimeout(() => {
      setPrizeMaskShow(false);
    }, 500);
  };

  const shareUid = getParamsFromHash("shareUid");
  const teamCode = getParamsFromHash("teamCode");
  const isRanking = getParamsFromHash("shareType") === "ranking";
  const [sharePeoInfo, setSharePeoInfo] = useState<ShareInfoData>({});
  const getSharePeo = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      const res = await getInvitationMessage({
        uid,
        activityCode,
        pageCode: activityInfo.pageCode,
        shareUid,
        teamCode,
      });
      console.log("%c Line:164 🍊 res", "color:#fca650", res);
      if (res.code == 200) {
        setSharePeoInfo(res.data);
        // 分享人信息查询
        PopupComRef.current?.onOpen();
      } else {
        // 查询人分享人信息失败 删除url分享人信息
        handleRemoveParam();
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error: any) {
    } finally {
      Loading.hide();
    }
  };
  useEffect(() => {
    if (shareUid) {
      if (isRanking) {
        getSharePeo();
      }
    }
  }, [shareUid]);
  // 加入队伍背景图
  const PopupComBacUrl = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("popSetting")
      ?.content("rankJoinTeam")?.val?.val;
    return result || moduleJsonData.visual.prizeSetting[2].content[2].val;
  }, [moduleJsonData]);
  const onCallback = async () => {
    try {
      Loading.show("加载中...");
      const uid = await getCurrentUid();
      //加入队伍回调
      const res = await joinTheTeam({
        uid,
        activityCode,
        pageCode: activityInfo.pageCode,
        shareUid,
        teamCode,
      });
      console.log("%c Line:93 🥥 res", "color:#ea7e5c", res);
      if (res.code == 200 && res.data) {
        Toast.show({
          content: "加入成功",
        });
      } else {
        Toast.show({
          content: res.msg,
        });
      }
    } catch (error: any) {
    } finally {
      Loading.hide();
      handleRemoveParam();
      getData();
    }
    // const activityInfo = props.activityInfo;
    trackGdp("P20217", "B002", {
      // 点击埋点
      trackName: "充电_排行榜_我的队伍_按钮点击",
      origin: getChannel(),
      activityId: activityInfo.connectedActivitiesId,
      clickLocation: "立即加入",
    });
  };
  const handleRemoveParam = () => {
    // const currentParams = new URLSearchParams(searchParams);
    // currentParams.delete("shareUid"); // 删除参数
    // currentParams.delete("shareType"); // 删除参数
    // currentParams.delete("teamCode"); // 删除参数
    // const newSearchParams = currentParams.toString();
    window.location.href = removeUrlParameters(window.location.href, [
      "shareUid",
      "shareType",
      "teamCode",
    ]);
  };
  // 页面信息
  const [rankObj, setRankObj] = useState<ActivityData>({ rankUpdateTime: "" });
  const [teamConfigData, setTeamConfigData] = useState<any>(null);
  async function getData() {
    try {
      Loading.show("加载中...");
      // 获取样式配置页面配置  type类型 打榜 busi-ranking
      const uid = await getCurrentUid();
      // 首页详情信息
      const data = (await chartRankingInfoList({
        uid,
        activityCode,
      })) as ActivityData;
      setRankObj(data || {});

      const { records } = (await teamMemberList({
        uid,
        activityCode,
      })) as ApiResponse;
      setTeamConfigData(records && records[0] ? records[0] : {});
      //设置调试使用假数据
      // setRankObj(homeData || {});
      // console.log("%c Line:8 🌰首页详情信息 ", "color:#33a5ff", data);
    } catch (error) {
      console.log("%c Line:134 🥥 error", "color:#7f2b82", error);
    } finally {
      Loading.hide();
    }
  }

  // 个人排行数据
  // 前三名数据
  const [topThreePersonal, setTopThreePersonal] = useState<UserActivityData[]>(
    [],
  );
  // 从第四名开始的数据
  const [rankDataList, setRankDataList] = useState<UserActivityData[]>([]);
  const [total, setTotal] = useState(0);
  const [isHaveData, setIsHaveData] = useState(true);
  const [loading, setLoading] = useState(false);
  const getRankingListData = async (flag: boolean, pageIndex?: number) => {
    try {
      setLoading(true);
      Loading.show("加载中...");

      // 获取当前模式的排名上限
      const currentRankLimit = flag ? personRankNum : teamRankNum;

      // 检查是否有上限配置
      if (currentRankLimit) {
        const currentDataCount = topThreePersonal.length + rankDataList.length;

        // 判断是否已经达到上限
        if (currentDataCount >= currentRankLimit) {
          console.log(`排行榜数据已达到上限: ${currentRankLimit}`);
          setIsHaveData(false);
          Loading.hide();
          setLoading(false);
          return;
        }

        // 计算本次请求可能会超出上限的情况
        const wouldExceedLimit = currentDataCount + pageSize > currentRankLimit;
        if (wouldExceedLimit) {
          // 调整本次请求的pageSize，只请求到达上限的数量
          pageSize = currentRankLimit - currentDataCount;
          if (pageSize <= 0) {
            console.log("已达到排行榜展示上限");
            setIsHaveData(false);
            Loading.hide();
            setLoading(false);
            return;
          }
        }
      }

      const uid = await getCurrentUid();
      const leaderboardFunction = flag
        ? individualLeaderboard
        : teamLeaderboard;
      // 个人排行信息
      const { records, total } = (await leaderboardFunction({
        pageNo: pageIndex || pageNo,
        pageSize,
        uid,
        activityCode,
      })) as IndividualLeaderboard;
      pageNo++;
      // 数据 从四名开始 才有列表显示
      if (total > 3) {
        setTotal(total - 3);
      } else {
        setTotal(total);
      }
      if (total == 0) {
        // 当数据为空时
        setIsHaveData(false);
      }
      setTopThreePersonal((prevArray) => {
        if (prevArray.length == 0 && records.length != 0) {
          // 第一次请求 或者切换个人或者排队模式的时候 刷新
          let rearranged: UserActivityData[] = [];
          if (records.length == 1) {
            rearranged = [records[0]];
          } else if (records.length == 2) {
            rearranged = [records[0], records[1]];
          } else {
            const topThree = records.splice(0, 3);
            rearranged = [topThree[1], topThree[0], topThree[2]];
          }
          return rearranged;
        } else if (prevArray.length == 1) {
          return [...prevArray, records[0]];
        } else if (prevArray.length == 2) {
          const topThree = records.splice(0, 1);
          return [prevArray[1], prevArray[0], topThree[0]];
        } else {
          return prevArray;
        }
      });
      const num = (pageNo - 1) * pageSize;
      if (num > 3 && total > 3) {
        // 一次请求的数量和 数据总量都大于3的时候才开始 设置从第4名开始的数据列表
        setRankDataList((prevArray) => [...prevArray, ...records]);
      }
      if (total <= 3 && (pageNo - 1) * pageSize >= total) {
        setIsHaveData(false);
      }

      // 检查是否已达到排行榜上限
      const rankLimit = flag ? personRankNum : teamRankNum;
      if (rankLimit) {
        const currentDataCount = topThreePersonal.length + rankDataList.length;
        if (currentDataCount >= rankLimit) {
          setIsHaveData(false);
        }
      }
    } catch (error) {
      console.log("%c Line:189 🍯 error", "color:#b03734", error);
    } finally {
      Loading.hide();
      setLoading(false);
    }
  };
  // 是否是个人排队模式
  const [isPeoModel, setIsPeoModel] = useState(true);
  const changeModel = (flag: boolean, isInit = false) => {
    console.log("rankObj-------", rankObj);
    if (isPeoModel != flag || isInit) {
      pageNo = 1;
      setTopThreePersonal([]);
      setRankDataList([]);
      setIsPeoModel(flag);

      // 根据模式设置正确的pageSize
      if (flag) {
        pageSize = personPageSize;
      } else {
        pageSize = teamPageSize;
      }

      getRankingListData(flag, pageNo);
      // const activityInfo = props.activityInfo;
      if (!isInit) {
        trackGdp("P20189", "B004", {
          trackName: "充电_营销专题页_组件点击",
          origin: getChannel(),
          userType: "",
          versionId: activityInfo.versionCode,
          pageId: activityInfo.pageCode,
          ComponentCode: activityInfo.moduleId,
          description: activityInfo.moduleRemark,
          type: activityInfo.moduleType,
          activityId: activityInfo.connectedActivitiesId,
          comp_style: "大型排行榜",
          status: rankObj.activityStatusCn || "",
          clickLocation: flag ? "个人排名" : "组队排名",
        });
      }
      setIsHaveData(true);
    }
  };

  // 刷新首页数据
  const onRefresh = (flag: boolean) => {
    getData();
    pageNo = 1;
    setTopThreePersonal([]);
    setRankDataList([]);
    setIsPeoModel(flag);

    // 根据模式设置正确的pageSize
    if (flag) {
      pageSize = personPageSize;
    } else {
      pageSize = teamPageSize;
    }

    getRankingListData(flag, pageNo);
  };
  useEffect(() => {
    // 个人
    if (isPeoModel) {
      pageSize = personPageSize;
    } else {
      // 组队
      pageSize = teamPageSize;
    }
  }, [isPeoModel, personPageSize, teamPageSize]);
  useEffect(() => {
    const isBigRanking =
      enhancedSafeChainFind(moduleJsonData.visual)?.visualData("visualStyle")
        ?.val?.typeName == "大活动排行榜" ||
      moduleJsonData.visual?.visualData[0]?.typeName == "大活动排行榜";
    if (isBigRanking) {
      // 如果是 大活动排行榜 不显示查看完整榜单
      setShowHomeFlag(false);
      localStorage.setItem(`isOneRankingOpen${activityInfo.moduleId}`, "1");
    }
    pageNo = 1;
    getData();
    // document.title = "排名";
    // 打开过首页回退不再显示首页
    const isOneRankingOpen =
      localStorage.getItem(`isOneRankingOpen${activityInfo.moduleId}`) || "";
    if (isOneRankingOpen == "1") {
      setShowHomeFlag(false);
      // 区分 首次加载是 个人排行 还是 组队排行
      const isTeam = moduleJsonData?.rewardSet?.rankingType == "2";
      // 判断 是否是只有队伍  如果是显示个人和显示全部的时候 都默认加载个人排行 需要传入 true
      changeModel(!isTeam, true);
    } else {
      // 小榜 外显逻辑
      // pageSize = moduleJsonData?.rankImg?.rankData[1]?.val
      const isTeam = isTeamType;
      changeModel(!isTeam, true);
    }
    setPmIndex(0);
    setPmjlData(moduleJsonData.rewardSet.rewardData[0]?.data || []);
    // 设置页面标题
    const pageVersionDto = JSON.parse(
      localStorage.getItem(`pageVersionDto${activityInfo.pageCode}`) || "{}",
    );
    document.title = pageVersionDto.pageTitle || pageVersionDto.pageName;
    track();
  }, []);
  const track = () => {
    trackGdp("P20189", "B003", {
      trackName: "充电_营销专题页_组件曝光",
      origin: getChannel(),
      userType: "",
      versionId: activityInfo.versionCode,
      pageId: activityInfo.pageCode,
      ComponentCode: activityInfo.moduleId,
      description: activityInfo.moduleRemark,
      type: activityInfo.moduleType,
      activityId: activityInfo.connectedActivitiesId,
      comp_style: "大型排行榜",
      index: "",
    });
  };
  return (
    <PageContainer>
      <div
        className={style["pageBox"]}
        style={{
          backgroundImage: `url(${processOssImage(boxBackUrl)})`,
          backgroundSize: "100% auto",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
          height: showHomeFlag ? "auto" : "100%",
          paddingBottom: showHomeFlag ? "20px" : "100px",
        }}
      >
        {!showHomeFlag && (
          <ActivityDetailButton
            mode="description"
            activityInfo={activityInfo}
            data={rankObj.activityDescribe || ""}
            activityDetailPopupRef={activityDetailPopupRef}
            buttonImage={hdxq}
            componentType="ranking"
            className={style["hdxq"]}
            activityId={activityInfo.connectedActivitiesId}
          />
        )}
        {!showHomeFlag && (
          <img
            src={processOssImage(pmjl)}
            className={style["pmjl"]}
            onClick={pmjlEvent}
          />
        )}
        <div className={style["titileBox"]}>
          <div className={style["bigTitile"]}>
            <FontSetBoxs
              content={titleContent}
              styleData={activityTitleStyleData}
            />
          </div>
          {showHomeFlag ? (
            <div className={style["seeAll"]} onClick={goSeeAll}>
              查看完整榜单
              <RightOutline />
            </div>
          ) : (
            <div style={{ wordBreak: "break-all" }}>
              <FontSetBox
                content={subTitleContent}
                styleData={activitySubTitleStyleData}
              />
            </div>
          )}
        </div>
        {!showHomeFlag && tabIsAll && (
          <div className={style["tabBox"]}>
            {/* {tabIsAll && ( */}
            <>
              <div
                className={isPeoModel ? style["tabBoxActive"] : ""}
                onClick={() => changeModel(true)}
              >
                个人排行
              </div>
              <div
                className={!isPeoModel ? style["tabBoxActive"] : ""}
                onClick={() => changeModel(false)}
              >
                组队排行
              </div>
            </>
            {/* )} */}
          </div>
        )}
        {!showHomeFlag && (
          <div className={style["timeBox"]}>
            <FontSetBox
              content={`${rankObj.activityStatus === "4" ? "" : "排行更新时间："}${rankObj.rankUpdateTime}`}
              styleData={updateTimeStyleData}
            />
            <div onClick={() => myAward()}>
              我的奖品
              <RightOutline />
            </div>
          </div>
        )}
        <div className={style["rankBox"]}>
          <OneTwoThreeBox
            list={topThreePersonal}
            moduleJsonData={moduleJsonData}
            isPeoModel={isPeoModel}
          />
          {!showHomeFlag && (
            <RankList
              showNum={(pageNo - 1) * pageSize}
              isShowMoreBtn={
                isHaveData &&
                total > rankDataList.length + 3 &&
                pageNo - 1 != 100 &&
                !loading
              }
              isNotMore={
                (total == rankDataList.length + 3 && !loading) ||
                (pageNo - 1 == 100 && !loading) ||
                !isHaveData
              }
              list={rankDataList}
              moduleJsonData={moduleJsonData}
              isPeoModel={isPeoModel}
              getMore={getRankingListData}
            />
          )}
        </div>
        {!showHomeFlag && (
          <FooterInfoBox
            onRefresh={onRefresh}
            activityInfo={activityInfo}
            infoObj={rankObj}
            moduleJsonData={moduleJsonData}
            isPeoModel={isPeoModel}
            teamConfigData={teamConfigData}
          />
        )}
        <PopupCom
          ref={PopupComRef}
          bacUrl={PopupComBacUrl}
          onCallback={onCallback}
          title="加入队伍"
          btnStr="立即加入"
          children={
            <div className={style["sharePeoInfo"]}>
              <div className={style["peoName"]}>
                用户{sharePeoInfo?.shareUserName}邀请您加入队伍
              </div>
              <div className={style["teamName"]}>{sharePeoInfo?.teamName}</div>
            </div>
          }
        />
        <PopupCom
          ref={pmjlPopUpRef}
          height="70%"
          bacUrl={pmjlBackUrl}
          onCallback={onCallback}
          onCloseCallBack={onCloseCallBack}
          children={
            <div className={style["pmjlDataBox"]}>
              <div className={style["title"]}>排名奖励</div>
              {moduleJsonData.rewardSet.rewardData.length == 2 && (
                <div className={style["tabBox"]}>
                  <div
                    className={pmIndex == 0 ? style["tabBoxActive"] : ""}
                    onClick={() => pmTabChange(0)}
                  >
                    个人奖励
                  </div>
                  <div
                    className={pmIndex == 1 ? style["tabBoxActive"] : ""}
                    onClick={() => pmTabChange(1)}
                  >
                    组队奖励
                  </div>
                </div>
              )}
              <div className={style["pmjlDataList"]}>
                {pmjlData?.map((item: any, i: number) => (
                  <div className={style["pmjlData"]} key={`pmjlData${i}`}>
                    <div className={style["pmjlData_title"]}>
                      <div className={style["rank"]}>
                        {item.rankBegin}-{item.rankEnd}名
                      </div>
                      {item.prizeCill != "0" && (
                        <div className={style["describe"]}>
                          {pmIndex == 0 ? "个人" : "组队累计"}
                          {activityValueName}须达到
                          {item.prizeCill}及以上能获得该奖励
                        </div>
                      )}
                    </div>
                    <div className={style["prizeList"]}>
                      {item.prizeList?.map((n: any, j: number) => (
                        <div
                          className={style["prizeList_data"]}
                          key={`prizeList_data${j}`}
                        >
                          <div className={style["prizeList_img"]}>
                            <img
                              src={processOssImage(n.val)}
                              alt="找不到图片"
                            />
                          </div>
                          <div
                            className={style["prizeList_font"]}
                            id="text-container"
                          >
                            {n.productName}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
        />
        {prizeMaskShow && <div className={style.prizeMask}></div>}

        {/* 活动详情弹窗组件 */}
        <ActivityDetailPopup ref={activityDetailPopupRef} />

        {/* 中奖记录弹窗组件 */}
        <PrizeRecordPopup
          ref={prizeRecordPopupRef}
          moduleJsonData={moduleJsonData}
          activityInfo={activityInfo}
        />
      </div>
    </PageContainer>
  );
};

export default App;
